export enum CheckboxType {
  Default = 'default',
  Button = 'button'
}
